// 导航
export const MENU_LIST = [
    {
        id: '1',
        name: '首页',
        code: 'index',
        icon: 'el-icon-s-home',
        english: 'HOME',
        path: '/',
    },
    {
        id: '2',
        name: '活动介绍',
        code: 'introduction',
        path: '/introduction',
        english: 'INTRODUCE',
    },
    // {
    //     id: '6',
    //     name: '赛事动态',
    //     code: 'dynamic',
    //     path: '/dynamic',
    //     english: 'TREBDS',
    // },
    {
        id: '8',
        name: '成绩及证书查询',
        code: 'scoreQuery',
        path: '/scoreQuery',
        english: 'SCOREQUERY',
    },
    {
        id: '9',
        name: '指导老师证书查询',
        code: 'certificateQuery',
        path: '/certificateQuery',
        english: 'CERTIFICATEQUERY',
    },
    // {
    //     id: '9',
    //     name: '证书查询',
    //     code: 'certificateQuery',
    //     path: '/certificateQuery',
    //     english: 'CERTIFICATE',
    // },
    // {
    //     id: '10',
    //     name: '报名中心',
    //     code: 'registrationCenter',
    //     path: '/registrationCenter',
    //     english: 'APPLICATION',
    // },
    {
        id: '11',
        name: '联系我们',
        code: 'contact',
        path: '/contact',
        english: 'CONTACT',
    },


]


// WEBPACK FOOTER //
// ./src/constants/common.js